import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BASE_URL_DOWNLOAD } from '../../../app.service';

@Component({
  selector: 'app-file-viewer',
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.css']
})
export class FileViewerComponent implements OnInit {

  filedata:any;
  public path_file:string;
  constructor(
    public dialogRef: MatDialogRef<FileViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) { 
    
      console.log(data);
      this.filedata = data;

      if(this.data.action==1){
        if(this.filedata.type==5 ){
          this.path_file = data.link;
        }
        else{
          this.path_file = BASE_URL_DOWNLOAD +  data.link;
        }
      }
      else{
        if(this.filedata.type==6 ){
          this.path_file = data.link;
        }
        else{
          this.path_file = BASE_URL_DOWNLOAD +  data.link;
        }
      }

     

      
  }

  ngOnInit(): void {
  }

}
